<div class="breadcrumb-extended">
  <div class="breadcrumb-container">
    <div *ngFor="let crumb of breadcrumb; last as isLast" class="mkt-breadcrumb">
      <a (click)="isLast ? null : onClickBreadcrumb(crumb)" [class.disabled]="isLast">{{crumb.name}}</a>
      <em class="icon-right_small" *ngIf="!isLast"></em>
    </div>
  </div>
  <ng-content></ng-content>
</div>
